module.exports = __webpack_public_path__ + "static/img/user-avatar.c641e26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user-avatar.jpg
// module id = 2650
// module chunks = 1